/* src/app/dashboard/ui/components/toolbar/data-type-filter/data-type-filter.component.scss */
.data-type-filter {
  margin-top: -5px;
  margin-right: 32px;
}
.data-type-filter label {
  display: block;
  color: #fff;
  font-weight: 700;
  font-size: 10px;
  line-height: 1.5;
  margin-top: 0px;
  margin-bottom: 0px;
}
.data-type-filter select {
  height: 32px;
  padding: 0 0.75em;
  border-radius: 4px;
  background-color: #fff;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
}
.data-type-filter select:disabled {
  background-color: #f5f5f5;
  cursor: not-allowed;
  opacity: 0.7;
}
/*# sourceMappingURL=data-type-filter.component-NR6TLGV6.css.map */
